module.exports = __webpack_public_path__ + "img/13800.736aee5b.jpg";